// NAD About Real Energy Section
// Handles fade in animation for the section

class NADAboutRealEnergy {
  private element: HTMLElement;
  private observer: IntersectionObserver | null = null;

  constructor(element: HTMLElement) {
    this.element = element;
    this.init();
  }

  private init(): void {
    this.setupIntersectionObserver();
  }

  private setupIntersectionObserver(): void {
    // Check if IntersectionObserver is supported
    if (!('IntersectionObserver' in window)) {
      // Fallback for browsers that don't support IntersectionObserver
      this.element.classList.add('nad-about-real-energy--animate-in');
      return;
    }

    // Create intersection observer
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Add animation class when element comes into view
            this.element.classList.add('nad-about-real-energy--animate-in');
            
            // Stop observing once animation is triggered
            if (this.observer) {
              this.observer.unobserve(this.element);
            }
          }
        });
      },
      {
        threshold: 0.1, // Trigger when 10% of the element is visible
        rootMargin: '0px 0px -50px 0px' // Start animation slightly before element is fully visible
      }
    );

    // Start observing the element
    this.observer.observe(this.element);
  }

  public destroy(): void {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

// Initialize all sections when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll<HTMLElement>('.nad-about-real-energy');
  
  sections.forEach((section) => {
    new NADAboutRealEnergy(section);
  });
});

// Export for potential external use
export { NADAboutRealEnergy };
